import { gql } from 'apollo-angular';

export const GET_EXCHANGE_RATE = gql`
    query GetExchangeRate {
        exchangeRate
    }
`;
